import React,{useState} from "react";
import "./EventActorList.css";
import { CheckCircle, XCircle, AlertTriangle, Shield, MapPin, Monitor, Globe, Clock, FileWarning,ChevronDown, ChevronUp } from "lucide-react";

const StatusIcon = ({ status }) => {
  const iconProps = { size: 16, strokeWidth: 2 };
  
  if (status === "SUCCESS") return <CheckCircle {...iconProps} />;
  if (status === "FAILURE") return <XCircle {...iconProps} />;
  return <AlertTriangle {...iconProps} />;
};

const RulesAccordion = ({ rules }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!rules || rules.length === 0) return null;

  return (
    <div className={`rules-accordion-wrapper ${isOpen ? 'is-active' : ''}`}>
      <button 
        className="rules-accordion-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="trigger-left">
          <div className={`icon-pill ${isOpen ? 'active' : ''}`}>
            <FileWarning size={14} />
          </div>
          <span className="trigger-label">
            Triggered Rules <span className="rule-count">{rules.length}</span>
          </span>
        </div>
        <div className={`chevron-wrapper ${isOpen ? 'rotate' : ''}`}>
          <ChevronDown size={16} />
        </div>
      </button>

      <div className={`rules-content-area ${isOpen ? 'expanded' : 'collapsed'}`}>
        <div className="rules-inner-list">
          {rules.map((rule, index) => (
            <div key={index} className="rule-row">
              <div className="rule-dot"></div>
              <span className="rule-text">{rule}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const formatTimestamp = (timestamp) => {
  if (!timestamp) return "Unknown time";

  try {
    // If it's an ISO string without timezone info, safely append 'Z' to treat it as UTC
    let safeTimestamp = timestamp;
    if (typeof timestamp === "string" && !timestamp.includes("Z") && !timestamp.includes("+")) {
      // Check if it looks like an ISO date before appending
      if (timestamp.includes("T") || timestamp.includes("-")) {
        safeTimestamp = `${timestamp}Z`;
      }
    }

    const date = new Date(safeTimestamp);

    // 1. Format to DD/MM/YYYY using IST timezone
    const datePart = date.toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    // 2. Format to hh:mm:ss am/pm using IST timezone
    const timePart = date.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).toLowerCase(); // Forces lowercase 'am/pm'

    // 3. Combine with a comma and space
    return `${datePart}, ${timePart}`;
  } catch (error) {
    return "Unknown time"; // Safe fallback if date parsing fails
  }
};

export const EventActorList = ({ events = [] }) => {
  return (
    <div className="event-stream">
      {events.map((e) => (
        <div key={e.id} className={`event-card ${e.status?.toLowerCase()}`}>
          <div className={`event-indicator ${e.status?.toLowerCase()}`}>
            <StatusIcon status={e.status} />
          </div>

          <div className="event-content">
            <div className="event-primary">
              <div className="event-title">
                <span className="actor-name">{e.actor || "Unknown Actor"}</span>
              </div>
              
              <div className="event-badges">
                <span className={`status-badge ${e.status?.toLowerCase()}`}>
                  <StatusIcon status={e.status} />
                  {e.status}
                </span>
                
                {e.risk_level && (
                  <span className={`risk-badge medium`}>
                    <Shield size={14} strokeWidth={2} />
                    {e.risk_level}
                  </span>
                )}
              </div>
            </div>

            <div className="event-metadata">
              <div className="metadata-item"><MapPin size={14} /><span>{e.location}</span></div>
              <div className="metadata-item"><Monitor size={14} /><span>{e.device}</span></div>
              <div className="metadata-item"><Globe size={14} /><span>{e.ip}</span></div>
              <div className="metadata-item"><Clock size={14} /><span>{formatTimestamp(e.timestamp)}</span></div>
            </div>

            {/* Replaced old static rules with Accordion component */}
            <RulesAccordion rules={e.triggered_rules} />

          </div>
        </div>
      ))}
    </div>
  );
};